// ** Logo
import logo from '../../../assets/images/logo/logo.png'
import connect from "react-redux/es/connect/connect";
import { Fragment } from "react";

const SpinnerComponent = (props) => {
    return (
        <Fragment>
            {(props.spinnerHandler || props.isRender) && <div className='fallback-spinner loading-container'>
                <div className='loading mt-0'>
                    <div className='effect-1 effects' />
                    <div className='effect-2 effects' />
                    <div className='effect-3 effects' />
                </div>
                <img className='fallback-logo bg-white rounded p-1' src={logo} alt='logo' />
            </div>}
        </Fragment>
    )
}
const mapStateToProps = (props) => ({
    spinnerHandler: props.loader.isLoading,
});
export default connect(mapStateToProps)(SpinnerComponent);

